export default __webpack_public_path__ + "media/Objective/Objective-Italic-62655c012ab0d47a705ed185452ee4f7.woff2";